import { KatalisTranslationRoutes } from '../translations.interface';

const messages: KatalisTranslationRoutes = {
  routes: {
    PainelDeControle: 'Painel de Controle',
    // amostras
    AmostrasEnsaios: 'Ensaios - Laboratório',
    AmostrasEnsaiosFireAssay: 'Ensaios - Laboratório',
    AmostrasIndexLaboratorioGuarulhos: 'Guarulhos - Laboratório',
    AmostrasIndexProducaoGuarulhos: 'Guarulhos - Produção',
    AmostrasIndexLaboratorio: 'Matriz - Laboratório',
    AmostrasCatalisadoresLaboratorioMatrizColeta: 'Matriz - Catalisadores',
    AmostrasCatalisadoresLaboratorioMatrizAtivas: 'Matriz - Catalisadores',
    AmostrasCatalisadoresLaboratorioMatrizFinalizadas: 'Matriz - Catalisadores',
    AmostrasGeralLaboratorioMatrizRecebimento: 'Matriz - Geral',
    AmostrasGeralLaboratorioMatrizAtivas: 'Matriz - Geral',
    AmostrasGeralLaboratorioMatrizFinalizadas: 'Matriz - Geral',
    AmostrasEnsaiosCarbono: 'Matriz - Carbono',
    AmostrasEnsaioUmidadeBalanca: 'Matriz - Umidade',
    AmostrasEnsaioFRX: 'Matriz - FRX',
    AmostrasEnsaioFRXQualitativo: 'Matriz - FRX Qualitativo',
    AmostrasEnsaioGravimetria: 'Matriz - Gravimetria',
    AmostrasEnsaioICP: 'Matriz - ICP',
    AmostrasEnsaioICPCobre: 'Matriz - ICP Cobre',
    AmostrasIcpUpload: 'Matriz - Upload Icp',
    AmostrasVer: 'Informações da amostra',
    AmostrasLaudo: 'Laudo da amostra',
    // amostras-catalisadores
    AmostrasCatalisadoresIndexProducao: 'Matriz - Produção',
    AmostrasCatalisadoresDisplay: 'Controle de Amostras',
    // amostras-comerciais
    AmostrasComerciaisIndex: 'Matriz - Comercial',
    // amostras-placas
    AmostrasPlacasIndexProducao: 'Guarulhos - Produção',
    // amostras-utinga
    AmostrasUtingaIndexProducao: 'Utinga - Produção',
    // auth
    AuthAtivarConta: 'Ativar conta',
    AuthEsqueciMinhaSenha: 'Esqueci minha senha',
    AuthLogin: 'Entrar no sistema',
    AuthRenovarSenha: 'Renovar senha',
    //bags
    BagsIndex: 'Cadastro de bags',
    //balancas
    BalancasIndex: 'Balanças',
    //fornecedores-sap
    FornecedoresSapIndex: 'Fornecedores',
    //pedidos-sap
    PedidosSapIndex: 'Pedidos',

    // erro
    ErroNaoEncontrado: 'Não encontrado',
  },
};

export default messages;
